export default __webpack_public_path__ + "static/media/Girdle of the Renegade.5bf0f152.jpg";